import { createFeatureSelector, createSelector } from '@ngrx/store';
import { map } from 'lodash';

import { Role } from '@lockton-apps/shared/interfaces';

import { AUTH_FEATURE_KEY, SharedDataAccessAuth } from './auth.reducer';

// Lookup the 'Auth' feature state managed by NgRx
export const getAuthState =
  createFeatureSelector<SharedDataAccessAuth>(AUTH_FEATURE_KEY);

export const getIsAuthenticated = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.isAuthenticated
);

export const getRequiresMfa = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.requiresMfa
);

export const getNameId = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.nameId
);

export const getUsername = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.username
);

export const getGivenName = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.givenName
);

export const getFamilyName = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.familyName
);

export const getEmails = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.emails
);

export const getRole = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.role
);

export const selectIsContact = createSelector(
  getRole,
  (role) => role === Role.Contact
);

export const getIsPrimaryContact = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.isPrimaryContact
);

export const getIsBasicContact = createSelector(
  getRole,
  getIsPrimaryContact,
  (role, isPrimaryContact) => role === Role.Contact && !isPrimaryContact
);

export const getAuthError = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.error
);

export const getIsLoading = createSelector(
  getAuthState,
  (state: SharedDataAccessAuth) => state.isLoading
);

// View Selectors

// View Model

export const getRoleAndIsPrimaryContact = createSelector(
  getRole,
  getIsPrimaryContact,
  (role, isPrimaryContact) => ({ role, isPrimaryContact })
);

export const getLoginViewModel = createSelector(
  getIsAuthenticated,
  getIsLoading,
  (authenticated, isLoading) => ({ authenticated, isLoading })
);

export const getAccountViewModel = createSelector(
  getAuthState,
  ({ givenName, familyName, emails }: SharedDataAccessAuth) => ({
    name: `${givenName} ${familyName}`,
    emails,
  })
);
